// The one app-wide word on the API's maintenance answer (`lib/maintenance.ts`): changes are
// paused, and so are the reads the app makes as POSTs (campaign overview, report queries, the
// forecast), which the freeze refuses like any change; GET reads are served. It names no
// reopening time: it cannot know one. Non-blocking: it sits above the screen and blocks
// nothing; the refused action still shows its own error where it was made.

import { useMaintenance } from '@/lib/maintenance';

export function MaintenanceBanner() {
  const active = useMaintenance();
  if (!active) return null;
  return (
    <div className="drawer-notice maintenance-banner" role="status" aria-live="polite">
      <span className="drawer-notice-ico" aria-hidden="true">i</span>
      <span>SMART is being upgraded: changes are paused, and some views may not load until the upgrade is done.</span>
    </div>
  );
}
